import { ref } from 'vue'
import { computedAsync } from '@vueuse/core'
import { EVuetifyDefaults } from './defaults'


const options = Object.entries(EVuetifyDefaults)
    .map(([title, value]) => ({ title, value }));

const currentDefaults = ref<EVuetifyDefaults>(EVuetifyDefaults.DEFAULT)

const instance = computedAsync(
    async () =>  {
        /*
      https://vueuse.org/core/computedAsync/
      Dependencies that are accessed asynchronously will not trigger re-evaluation of the async computed value.
      */
        const temp = currentDefaults.value
        const { default: comp } = await import(`./defaults/${currentDefaults.value}.ts`)
        return comp
    },
    {} // initial state
)

// by convention, composable function names start with "use"
export const useVuetifyDefault = () => {
    const switchDefaults = (v:EVuetifyDefaults) => currentDefaults.value = v
    return { options, instance, switchDefaults, currentDefaults }
}